import styled from 'styled-components';

interface DfmSummaryItemStyledProps {
  failed: boolean;
}

export const DfmSummaryItemStyled = styled.div<DfmSummaryItemStyledProps>(
  ({ theme, failed }) => ({
    paddingTop: theme.borderRadius.xsmall,
    paddingBottom: theme.borderRadius.xsmall,
    display: 'grid',
    gridTemplateColumns: '30px 128px 35px 45px 18px 45px auto auto',
    width: '100%',
    alignItems: 'center',
    fontSize: theme.font.size.small,
    lineHeight: theme.font.lineHeight.medium,
    color: theme.color.wfGrey900,
    '&:hover': {
      background: failed && theme.color.wfYellow100,
      cursor: failed ? 'crosshair' : 'default',
    },
  }),
);
